"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Tooltip_meta_1 = require("../Tooltip.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var Icon_1 = __importDefault(require("../../Icon/Icon"));

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(Icon_1.default, Tooltip_meta_1.TOOLTIP_CATEGORY_KEY, Tooltip_meta_1.TOOLTIP_COMPONENT_KEY, ['tooltipIcon']);